// extracted by mini-css-extract-plugin
module.exports = {"accessories":"accessories_accessories__9H2b6","dropDownMenu":"accessories_dropDownMenu__qvIUp"};